import { Component, Input, AfterViewInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ArticleService } from '../article.service';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { NavService } from '../../header/nav/nav.service';
import { ContentComponent } from '../../article/content/content.component';
import { ISubscription } from 'rxjs/Subscription';
import { SharedService } from '../../common/shared.service';

@Component({
  selector: 'gosg-leftmenu',
  templateUrl: './leftmenu.component.html',
  styleUrls:['./leftmenu.component.css'],
  encapsulation: ViewEncapsulation.None
})

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: July 17th 2018
 * 
 * Description: Component class to populate left menu navigation
 **/
export class LeftmenuComponent implements AfterViewInit, OnDestroy {
  fontName: any = "Arial";
  agencyActive: boolean = false;
  statusID: any;
  paramURL: any;
  paramURL_Next: any;
  @Input() sessions: any;
  @Input() menuType: any;
  @Input() templateName: any;
  loading: boolean = false;
  private subscriptionFontSize: ISubscription;
  public myflag: any;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  constructor(private sharedService: SharedService, private router:Router,  public articleService: ArticleService, private navService: NavService, private activatedRoute: ActivatedRoute, private content:ContentComponent){
    this.activatedRoute.queryParams.subscribe(params => {
      this.paramURL = this.activatedRoute.snapshot.url[0].path;
      this.paramURL_Next = this.paramURL + '/' +this.activatedRoute.snapshot.url[1].path;
    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      $('.mat-expansion-panel-header-title > a').css('font-size', this.fontSize.sizeS);
    });

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
      } else {
        this.myflag = null;
      } 
    });
  }


  ngAfterViewInit() {
      this.fontName = localStorage.getItem('customFontType');
      if (this.fontName) {
        $('.mat-expansion-panel-header-title > a').css('font-family', this.fontName);
      }
    
      this.sharedService.loadFontSizeData();
  }

  ngOnDestroy() {
    this.subscriptionFontSize.unsubscribe();
  }

  boolCallback = (result: boolean) : void => {
    this.loading = result;
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }

  clickSideMenu(e, status, event) {
    this.navService.lfcontent = false;
    this.articleService.leContent = "";
    //this.navService.loader = true;
    this.statusID = status;
    this.agencyActive = false;
    if(this.paramURL_Next == 'archive/category'){
      this.router.navigate(['/archive/subcategory', e.categoryCode], { queryParams: this.myflag });
    }else if(this.paramURL == 'category'){
      this.router.navigate(['/subcategory', e.categoryCode], { queryParams: this.myflag });
    }else if(this.paramURL == 'subcategory'){

      this.navService.getSubArticleUrl(e.categoryId, localStorage.getItem('langID'));
      //this.navService.triggerSubArticle(e.categoryCode, localStorage.getItem('langID'));
      this.router.navigate(['/subcategory', e.categoryCode], { queryParams: this.myflag });
    }else if(this.paramURL_Next == 'archive/subcategory'){

      this.navService.getSubArticleUrlOthers(e.categoryId, localStorage.getItem('langID'),'archive');
      this.navService.triggerSubArticleOther(e.categoryCode, localStorage.getItem('langID'),'archive');
      this.router.navigate(['/archive/subcategory', e.categoryCode], { queryParams: this.myflag });
    }else if(this.paramURL_Next == 'archive/content'){

      this.navService.getSubArticleUrlOthers(e.categoryId, localStorage.getItem('langID'),'archive');
      this.navService.triggerSubArticleOther(e.categoryCode, localStorage.getItem('langID'),'archive');
      this.router.navigate(['/archive/subcategory', e.categoryCode], { queryParams: this.myflag });
    }else{
      this.router.navigate(['/subcategory', e.categoryCode], { queryParams: this.myflag });
    }
    event.preventDefault();
  }

  clickContentFromMenu(pId, aId, status, event) {
    this.navService.lfcontent = true;
    this.articleService.leContent = "";
    //this.navService.loader = true;
    this.statusID = status;
    if(this.paramURL == 'category'){
      this.router.navigate(['/content', aId], { queryParams: this.myflag });
    }else if(this.paramURL_Next == 'archive/category'){
      this.router.navigate(['/archive/content', aId], { queryParams: this.myflag });
    }else if(this.paramURL == 'subcategory'){
      this.router.navigate(['/content', aId], { queryParams: this.myflag });
      // this.content.getRateReset();
    }else if(this.paramURL_Next == 'archive/subcategory'){
      this.router.navigate(['/archive/content', aId], { queryParams: this.myflag });
      // this.content.getRateReset();
    }else if(this.paramURL_Next == 'archive/content'){
      this.navService.triggerContentOther(aId, localStorage.getItem('langID'),'archive');
      this.navService.getContentUrlOther(aId, localStorage.getItem('langID'), 'archive');
      this.router.navigate(['/archive/content', aId], { queryParams: this.myflag });
      // this.content.getRateReset();
    }else{
      this.navService.triggerContent(aId, localStorage.getItem('langID'));
      this.navService.getContentUrl(aId, localStorage.getItem('langID'));

      this.router.navigate(['/content',  aId], { queryParams: this.myflag });
      this.content.getRateReset();
    }
    event.preventDefault();
  }

  clickSideMenuByAgency(e, status, event) {
    this.articleService.leContent = "";
    //this.navService.loader = true;
    this.agencyActive = true;
    if(this.paramURL == 'category'){
      this.router.navigate(['/subcategory', 'agency'], { queryParams: this.myflag });
    }else if(this.paramURL == 'subcategory'){
      this.navService.getSubArticleUrlByAgency(localStorage.getItem('langID'));
      //this.navService.triggerSubArticleAgency(localStorage.getItem('langID'));
      this.router.navigate(['/subcategory', 'agency'], { queryParams: this.myflag });
    }else{
      this.router.navigate(['/subcategory', 'agency'], { queryParams: this.myflag });
    }

    event.preventDefault();
  }

}



// WEBPACK FOOTER //
// ./src/app/article/leftmenu/leftmenu.component.ts